import React from "react";
import "./Footer.css";
import { useNavigate } from "react-router-dom";
import {
  MailOutlined,
} from "@ant-design/icons";
import { FOOTER_CONTENT } from "../../utilities/localization";
import { OUR_CONTACT_INFO } from "../../utilities/constant";
import discordLogo from "../../images/discord-icon.png";
import PATHS from "../../routes/path";

const SOCIAL_LINKS = [
  {
    id: 1,
    icon: <img src={discordLogo} alt="Discord" className="discord-icon-footer" />,
    type: "external",
    url: OUR_CONTACT_INFO.DISCORD_LINK,
  },
  {
    id: 2,
    icon: <MailOutlined />,
    type: "internal",
    url: PATHS.CONTACT,
  },
];

const SocialItem = ({ item }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (item.type === "external") {
      window.open(item.url, "_blank", "noopener,noreferrer");
    } else {
      navigate(item.url);
    }
  };

  return (
    <div className="footer-social-item" onClick={handleClick}>
      {item.icon}
    </div>
  );
};

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-left">
          {FOOTER_CONTENT.COPYRIGHT}
        </div>

        <div className="footer-socials">
          {SOCIAL_LINKS.map((item) => (
            <SocialItem key={item.id} item={item} />
          ))}
        </div>
      </div>
    </footer>
  );
}

export default React.memo(Footer);